module.exports = __webpack_public_path__ + "img/md-search.ca1a8eca.svg";